const participation = ['#0097C4', '#00613F', '#D59C29']; // More, no difference, less
const scale = ['#19244d', '#2e3f8a', '#4774c2', '#83abd8', '#cae5f7']; // 1 best, 2, 3, 4, 5 worst

export { participation, scale };
